import { render, staticRenderFns } from "./VlArchiveButtons.vue?vue&type=template&id=3c0f74d4&scoped=true&"
import script from "./VlArchiveButtons.vue?vue&type=script&lang=js&"
export * from "./VlArchiveButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f74d4",
  null
  
)

export default component.exports